<template>
  <div class="html_seasonMatch" :class="themeClass" v-if="pareData.title">
    <span
      class="theme_publishBtn"
      @click="clickPublish('seasonMatch', pareData)"
      v-if="themeClass !== 'broadcastList'"
    >
      <svg
        t="1692698307306"
        class="publishBtn_icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="9670"
        width="50%"
        height="50%"
      >
        <path
          d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
          p-id="9671"
        ></path>
      </svg>
    </span>
    <span class="floor1Item_title" v-text="pareData.title"></span>
    <span class="floor1Item_mainVal">
      <span class="mainVal" v-text="pareData.data.played"></span>
      <span
        class="otherVal"
        v-text="pareData.data.total ? `/${pareData.data.total}` : ''"
      ></span>
    </span>
    <span class="floor1Item_DesVal">
      <span class="desVal" v-text="`平 ${pareData.data.draw}`"></span>
      <span class="desVal" v-text="`加时 ${pareData.data.extraTime}`"></span>
      <span class="desVal" v-text="`点球决胜 ${pareData.data.penalty}`"></span>
    </span>
    <span class="floor1Item_progressBar">
      <span class="progressBar_title" v-text="pareData.data.stageName"></span>
      <span class="progressBar_barBg">
        <span
          class="progressBar_barVal"
          :style="{
            width: `${(pareData.data.current / pareData.data.max) * 100}%`,
          }"
        ></span>
      </span>
    </span>
    <span class="floor1Item_footballField floor1_pic"></span>
  </div>
</template>

<script>
// 数据概览 - 比赛
export default {
  name: 'html_seasonMatch',
  props: {
    pareData: {
      type: Object,
      default: () => ({
        title: '',
        data: {
          current: 0,
          draw: 0,
          extraTime: 0,
          max: 1,
          penalty: 0,
          played: 0,
          stageName: '',
          total: 0,
        },
      }),
    },
    themeClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    clickPublish(mode, themeItem) {
      this.$emit('clickPublishEvent', {
        mode,
        themeItem,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.html_seasonMatch {
  position: relative;
  width: calc((100% - (2 * 1.388vw)) / 3);
  margin-right: 1.388vw;
  height: 14.583vw;
  color: var(--mixtmt_whiteColor);
  background: linear-gradient(
    90deg,
    var(--mixtmt_mainColor0) 0%,
    var(--mixtmt_mainColor3) 100%
  );
  border-radius: 0.556vw;
  &.broadcastList {
    width: 80%;
    height: 16.93vw;
  }
  &:last-child {
    margin-right: 0;
  }
  .theme_publishBtn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: 2.778vw;
    height: 2.778vw;
    line-height: 2.778vw;
    text-align: center;
    opacity: 0.7;
    svg.publishBtn_icon {
      fill: var(--mixtmt_whiteColor);
    }
  }
  .floor1Item_title {
    display: block;
    padding: 1.388vw 0 0 2.083vw;
    font-size: 1.25vw;
    height: 3.12vw;
    font-weight: bold;
  }
  .floor1Item_mainVal {
    padding: 1.04vw 0 0 2.083vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: baseline;
    .mainVal {
      font-size: 2.083vw;
      font-weight: bold;
    }
    .otherVal {
      font-size: 1.25vw;
    }
  }
  .floor1Item_DesVal {
    padding: 1.04vw 0 0.972vw 2.083vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid var(--mixtmt_greyColor9);
    .desVal {
      padding-right: 1.388vw;
      font-size: 0.972vw;
      line-height: 1.388vw;
      &:last-child {
        padding-right: 0;
      }
    }
  }
  .floor1Item_progressBar {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 5;
    padding: 0 2.083vw;
    width: 100%;
    height: 4.16vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;
    .progressBar_title {
      font-size: 0.972vw;
      line-height: 1.388vw;
      text-align: right;
    }
    .progressBar_barBg {
      position: relative;
      margin-top: 0.347vw;
      width: 100%;
      height: 0.416vw;
      background-color: var(--mixtmt_whiteColor);
      border-radius: 0.278vw;
      .progressBar_barVal {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        height: 100%;
        background-color: var(--mixtmt_subColor1_3);
        border-radius: 0.278vw;
        transition: width 0.3s linear;
      }
    }
  }
  .floor1Item_footballField {
    position: absolute;
    right: 1.388vw;
    top: 1.11vw;
    z-index: 3;
    width: 13.19vw;
    height: 6.25vw;
    background-size: 100% auto;
    background-position: right top;
    background-repeat: no-repeat;
    &.floor1_pic {
      background-image: var(--mixtmt_dataOverview_floor1_pic);
    }
  }
}

.mixtmt_pc {
  .html_seasonMatch {
    .theme_publishBtn {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
